import type { ReactNode } from "react";

import { useOrganizationWebhookConfig } from "../hooks/useOrganizationWebhookConfig";
import { OrganizationWebhooksContext } from "./OrganizationWebhooksContext";

/**
 * Instantiates the endpoint read once for the whole Settings page. Two consumers need it: the sub-nav, which
 * hides the Webhooks section when the backend answers the read with a 403, and the section body itself.
 * Without the provider each would fetch on its own — the same duplicate-read problem `AccessDataProvider`
 * exists to avoid. Mounted only for organization members; staff never see the section.
 */
export function OrganizationWebhooksProvider({ children }: { children: ReactNode }) {
  const data = useOrganizationWebhookConfig();
  return <OrganizationWebhooksContext.Provider value={data}>{children}</OrganizationWebhooksContext.Provider>;
}
